import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

@Component({
    components: { },
})
export default class App extends Vue {}
